import { observable, computed, action } from 'mobx';
import { API_URL } from '../constants/constants';
import { CompanyStore } from './CompanyStore';
import { NotificationStore } from './NotificationStore';

class FeedbackStore {
  public notificationStore: NotificationStore;
  public companyStore: CompanyStore;
  private title: string;
  private body: string;

  constructor(notificationStore: NotificationStore, companyStore: CompanyStore) {
    this.notificationStore = notificationStore;
    this.companyStore = companyStore;
    this.title = '';
    this.body = '';
  }

  @computed
  get feedback() {
    return { title: this.title, body: this.body };
  }

  @action
  setFeedback(title: string, body: string) {
    this.title = title;
    this.body = body;
  }

  @action
  clearStore() {
    this.title = '';
    this.body = '';
  }

  @action
  sendFeedback() {
    const token = localStorage.getItem('token');
    const url = `${API_URL}/v1/feedback`;
    const headers = new Headers();
    headers.append('Content-type', 'application/json');
    headers.append('X-CSRF-TOKEN', `${token}`);
    const payload = { title: this.title, body: this.body };

    return fetch(url, {
      headers: headers,
      method: 'POST',
      credentials: 'include',
      body: JSON.stringify(payload)
    });
  }
}

export default FeedbackStore;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/stores/FeedbackStore.ts